import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconFile from '@/icons/File.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingDispatchAcceptationNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_dispatch_acceptation'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const workshopName = notification.data.onBehalfOfWorkshop?.name;

  return (
    <BaseNotification
      notificationLabel={
        notification.data.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-dispatch-acceptation.label.on-behalf',
              message: `New job to validate for request ${requestReference} on behalf of ${workshopName}`,
            })
          : t({
              id: 'notification.pending-dispatch-acceptation.label',
              message: `New job to validate for request ${requestReference}`,
            })
      }
      icon={<IconFile />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-dispatch-acceptation.on-behalf">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new job to validate on behalf of{' '}
            <InlineText weight="medium" color={color}>
              {workshopName}
            </InlineText>
            .
          </Trans>
        ) : (
          <Trans id="notification.pending-dispatch-acceptation">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new job to validate
          </Trans>
        )
      }
    />
  );
};
